import { useEffect } from "react";
import { ErrorToastContainer } from "../../function/CustomFunction";

export default function Razorpay({ paymentInfo,handlePaymentStatus }) {
  useEffect(() => {
    if (!paymentInfo || paymentInfo.payment_getway !== "Razorpay") return;
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      try {
        const options = {
          key: paymentInfo.key,
          currency: "INR",
          description: "Campaigning Tool",
          order_id: paymentInfo.gateway_ref_no,
          handler: function () {
            handlePaymentStatus();
          },
          
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (err) {
        ErrorToastContainer("Payment gateway error");
        return false;
      }
    };

    script.onerror = () =>
    ErrorToastContainer("Payment gateway loading failed");
    document.body.appendChild(script);
    return () => {
      try {
        document.body.removeChild(script);
      } catch (e) {}
    };
  }, [paymentInfo]);

  return null;
}